/**
 * LoggingTabs Component
 *
 * Tab navigation for different entry types in the logging page.
 * Ordered by frequency: Makanan (most common) first.
 */

export type TabType = 'makanan' | 'olahraga' | 'berat' | 'kesehatan' | 'medis' | 'aktivitas';

interface Tab {
	id: TabType;
	label: string;
}

const tabs: Tab[] = [
	{ id: 'makanan', label: 'Makanan' },
	{ id: 'olahraga', label: 'Olahraga' },
	{ id: 'berat', label: 'Berat' },
	{ id: 'kesehatan', label: 'Kesehatan' },
	{ id: 'medis', label: 'Medis' },
	{ id: 'aktivitas', label: 'Aktivitas' },
];

interface LoggingTabsProps {
	activeTab: TabType;
	onTabChange: (tab: TabType) => void;
}

export function LoggingTabs({ activeTab, onTabChange }: LoggingTabsProps) {
	return (
		<div className="border-b border-gray-200">
			<nav
				className="flex overflow-x-auto scrollbar-hide -mb-px"
				aria-label="Tabs"
			>
				{tabs.map((tab) => {
					const isActive = activeTab === tab.id;
					return (
						<button
							key={tab.id}
							onClick={() => onTabChange(tab.id)}
							className={`
								flex-shrink-0 px-4 py-3 text-sm font-medium border-b-2 transition
								${
									isActive
										? 'border-blue-500 text-blue-600'
										: 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
								}
							`}
							aria-current={isActive ? 'page' : undefined}
						>
							{tab.label}
						</button>
					);
				})}
			</nav>
		</div>
	);
}
